import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../components/landing"
import { hecsGuide } from "../content/hecs-repayment-calculator"
import { guideSeo } from "./guides.$slug"

const PATH = "/hecs-repayment-calculator"

/** Free HELP repayment calculator (T917); the content is a `Guide`, the URL is top level (copy-products.md). */
export const hecsSeo = () => guideSeo(hecsGuide, PATH)

export const Route = createFileRoute("/_brand-layout/hecs-repayment-calculator")({
  head: () => {
    const { meta, links, scripts } = hecsSeo()
    return { meta, links, scripts }
  },
  component: () => <GuidePage guide={hecsGuide} />,
})
